import RichText from "@/components/RichText";

// Body strings authored via the RichTextEditor come in as HTML. Legacy seed
// data still comes in as plain text. This helper picks the right renderer so
// old content keeps its line breaks and new content honours bold/links/bullets.
function isProbablyHtml(str) {
  return typeof str === "string" && /<\w+[\s>]/i.test(str);
}

/**
 * Text block: heading + paragraph body. Supports left or center alignment.
 * Body is authored via the RichTextEditor (bold, links, headings, bullets);
 * plain-text bodies fall back to `whitespace-pre-line` for line breaks.
 */
export default function TextBlock({ data }) {
  const { heading, body, alignment = "left" } = data || {};
  const align = alignment === "center" ? "text-center" : "text-left";
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 ${align}`}>
        {heading && (
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 mb-4">
            {heading}
          </h2>
        )}
        {body && (
          isProbablyHtml(body) ? (
            <RichText
              html={body}
              className="prose prose-slate max-w-none prose-a:text-sky-600 prose-a:no-underline hover:prose-a:underline text-base text-slate-600 leading-relaxed"
            />
          ) : (
            <p className="text-base text-slate-600 leading-relaxed whitespace-pre-line">
              {body}
            </p>
          )
        )}
      </div>
    </section>
  );
}
